export default __webpack_public_path__ + "static/media/google.0e75895c.svg";